function extractParams(paramString) {
  // Two regexps instead of one since we don't know the order of the params in the query string.
  if (paramString) {
    const orderIdExtractor = /[?&]{1}purchaseId=(\d*)/;
    const productsExtractor = /[?&]{1}lineItemId=(\d*)/;
    const orderId = (paramString.match(orderIdExtractor) || [])[1] || '';
    const products = (paramString.match(productsExtractor) || [])[1] || '';
    return { orderId, products };
  }

  return {};
}

function getDaysRemaining(orderDate, nowTime = new Date().getTime()) {
  if (!orderDate) {
    return 0;
  }

  const formattedDate = new Date(orderDate.split(' at ').join(' '));
  const expireTime = formattedDate.setFullYear(formattedDate.getFullYear() + 1);
  return Math.floor((new Date(expireTime - formattedDate.getMilliseconds()).getTime() - nowTime) / 86400000); // milliseconds in a day
}

const ReturnsUtils = {
  extractParams,
  getDaysRemaining
};

export default ReturnsUtils;
